// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"853c5812","221":"7897d26c","561":"b7916003","574":"2c767536","821":"2560ae12","989":"38e60acb"}[chunkId] + ".chunk.css";
};